'use es6';

import { Record } from 'immutable';
const DEFAULTS = {
  categoryId: null,
  id: null,
  subcategory: ''
};
export default class MABContentInfo extends Record(DEFAULTS) {
  static fromJS(content) {
    return new MABContentInfo({
      categoryId: content.categoryId,
      id: content.id,
      subcategory: content.subcategory
    });
  }

}